import AppPermissions from './index.jsx';
import messages from './messages.js';

const template = {
  header: messages.community,
  helpHeader: messages.optionsHelp,
  options: [
    { value: 2, label: messages.readOnly, help: messages.readOnlyHelp },
    { value: 6, label: messages.readLike, help: messages.readLikeHelp },
    { value: 14, label: messages.readCommentLike, help: messages.readCommentLikeHelp },
    { value: 30, label: messages.write, help: messages.writeHelp },
    { value: 62, label: messages.moderate, help: messages.moderateHelp },
  ],
  exceptions: true,
};

function CommunityPermissions(props) {
  return AppPermissions({ ...props, template });
}

export default CommunityPermissions;
